/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

const isNotLegacySlider = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'LEGACY_SLIDER',
]);

const isNotSlideWithContent = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'contentActive',
  '!==',
  true,
]);

export default [
  ...[
    getFilterWithCol(['FieldRadio', {
      name: 'slider_size',
      label: null,
      initialValue: 'medium',
      choices: [
        { value: 'small', label: 'Small' },
        { value: 'medium', label: 'Medium' },
        { value: 'large', label: 'Large' },
      ],
      block: true,
    }], 24),
    getFilterWithCol(['FieldRadio', {
      name: 'slider_autoplay',
      label: null,
      initialValue: false,
      choices: [
        { value: false, label: 'Autoplay Off' },
        { value: true, label: 'Autoplay On' },
      ],
      block: true,
    }], 12),
    getFilterWithCol(['FieldRadio', {
      name: 'slider_overflow',
      label: null,
      initialValue: false,
      choices: [
        { value: false, label: 'Overflow Off' },
        { value: true, label: 'Overflow On' },
      ],
      block: true,
    }], 12),
    ['FieldSortableList', {
      name: 'slider_items',
      label: null,
      addButtonLabel: 'Add Slide',
      supportDuplicate: true,
      collapseFieldName: '__collapsed',
      collapseLabelFieldName: 'contentTitle',
      shouldRenderPlaceholder: true,
      collapseLabelDefault: 'Slide',
      condensed: true,
      fields: [
        getFilterWithCol(['FieldUploadRefsHorizontal', {
          name: 'image',
          label: null,
          maxCount: 1,
          accept: 'image/jpg,image/jpeg,image/png,image/webp',
          transformations: [
            ['GM', { command: 'compress', maxWidth: 2400 }],
            ['GM', { command: 'webp' }],
          ],
          listType: 'picture',
          uploadLabel: 'Upload Image',
        }], 12),
        getFilterWithCol(['FieldUploadRefsHorizontal', {
          name: 'imageMobile',
          label: null,
          maxCount: 1,
          accept: 'image/jpg,image/jpeg,image/png,image/webp',
          transformations: [
            ['GM', { command: 'compress', maxWidth: 1600 }],
            ['GM', { command: 'webp' }],
          ],
          listType: 'picture',
          uploadLabel: 'Upload Mobile Image',
        }], 12),
        getFilterWithCol(['FieldUploadRefsHorizontal', {
          name: 'video',
          label: null,
          maxCount: 1,
          accept: 'video/mp4',
          transformations: [],
          listType: 'picture',
          uploadLabel: 'Upload Video',
        }], 12),
        getFilterWithCol(['FieldUploadRefsHorizontal', {
          name: 'videoMobile',
          label: null,
          maxCount: 1,
          accept: 'video/mp4',
          transformations: [],
          listType: 'picture',
          uploadLabel: 'Upload Mobile Video',
        }], 12),
        getFilterWithCol(['FieldRadio', {
          name: 'contentActive',
          label: null,
          // inlineLabelBefore: 'Use Content?',
          initialValue: false,
          choices: [{
            label: 'Media Only',
            value: false,
          }, {
            label: 'Use Content',
            value: true,
          }],
          block: true,
        }], 24),
        getFilterWithCol(['FieldText', {
          name: 'contentTitle',
          label: null,
          prefix: 'Title:',
          skip: [isNotSlideWithContent],
        }], 12),
        getFilterWithCol(['FieldText', {
          name: 'contentSubtitle',
          label: null,
          prefix: 'Subtitle:',
          skip: [isNotSlideWithContent],
        }], 12),
        getFilterWithCol(['FieldText', {
          name: 'contentButtonLink',
          label: null,
          prefix: 'Link:',
          skip: [isNotSlideWithContent],
        }], 12),
        getFilterWithCol(['FieldText', {
          name: 'contentButtonLabel',
          label: null,
          prefix: 'Button:',
          skip: [isNotSlideWithContent],
        }], 12),
      ],
    }],
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotLegacySlider, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
